import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { canUploadNow, creatorOf, useAuth } from "../AuthContext.js";
import { logout } from "../api.js";
import CreatorBadge from "./CreatorBadge.js";

export default function Layout() {
  const { identity, loading, refresh } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="app-shell">
        <main>
          <p className="status-message">Loading…</p>
        </main>
      </div>
    );
  }

  const creator = creatorOf(identity);
  const isAdmin = creator?.isAdmin ?? false;
  const uploadAllowed = canUploadNow(identity);

  async function onLogout() {
    await logout();
    refresh();
    navigate("/login");
  }

  return (
    <div className="app-shell">
      <header className="site-header">
        <Link to="/" className="brand">
          CoinfallSMP <span>Publish</span>
        </Link>
        <nav>
          <NavLink to="/" end>
            {isAdmin ? "Library" : "My Videos"}
          </NavLink>
          {uploadAllowed ? <NavLink to="/new">Upload</NavLink> : null}
          {uploadAllowed ? <NavLink to="/import">YouTube import</NavLink> : null}
          <NavLink to="/jobs">Jobs</NavLink>
          {isAdmin ? <NavLink to="/creators">Creators</NavLink> : null}
          {isAdmin ? <NavLink to="/applications">Applications</NavLink> : null}
          {creator ? <NavLink to="/profile">My Profile</NavLink> : null}
        </nav>
        <div className="identity-chip">
          {creator ? (
            <>
              <CreatorBadge badge={creator.isOfficial ? "official" : creator.isVerified ? "verified" : null} />
              <span>{creator.displayName}</span>
              <button className="button secondary" onClick={onLogout}>
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="button secondary">
                Log in
              </Link>
              <Link to="/apply" className="button primary">
                Apply for Creator
              </Link>
            </>
          )}
        </div>
      </header>
      {creator && creator.mustResetPassword ? (
        <div className="dev-banner creator-pending-banner">
          You're logged in with a temporary password —{" "}
          <Link to="/profile">change it</Link> before continuing.
        </div>
      ) : null}
      {creator && !isAdmin && !uploadAllowed ? (
        <div className="dev-banner creator-pending-banner">
          Your creator account is <strong>{creator.status}</strong> and upload permission is{" "}
          {creator.canUpload ? "enabled" : "not yet enabled"} — an admin needs to approve your
          account and enable uploads before you can publish videos.
        </div>
      ) : null}
      <main>
        <Outlet />
      </main>
    </div>
  );
}
